import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDeliveryPersonWhite = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 170 170",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			stroke: "currentColor",
			d: "M140.78 123.179C150.954 122.772 159.922 129.8 161.959 139.775C162.165 140.792 161.905 141.847 161.251 142.651C160.664 143.528 159.534 143.859 158.566 143.438H93.1661C91.3616 143.634 89.5607 143.037 88.2312 141.801C86.9016 140.565 86.1745 138.813 86.2386 136.999V136.956C86.2386 131.63 84.1229 126.523 80.3569 122.757C76.591 118.991 71.4832 116.875 66.1573 116.875H44.029C38.7031 116.875 33.5954 118.991 29.8294 122.757C26.0635 126.523 23.9478 131.63 23.9478 136.956V143.926",
			strokeWidth: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "currentColor",
			d: "M130.156 85H140.781V143.438",
			strokeWidth: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "currentColor",
			d: "M66.1572 116.875H92.9676",
			strokeWidth: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "currentColor",
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M7.96875 63.75C7.96875 60.816 10.3472 58.4375 13.2813 58.4375H45.1563C48.0903 58.4375 50.4688 60.816 50.4688 63.75V90.3125C50.4688 93.2465 48.0903 95.625 45.1563 95.625H13.2813C10.3472 95.625 7.96875 93.2465 7.96875 90.3125V63.75Z",
			strokeWidth: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "currentColor",
			d: "M140.781 93.0682L154.346 87.6778C156.019 87.0242 157.887 87.0908 159.51 87.862C160.97 88.4751 161.951 89.871 162.031 91.4532V107.341C161.951 108.923 160.97 110.319 159.51 110.932C157.887 111.704 156.019 111.77 154.346 111.117L140.781 105.726",
			strokeWidth: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "currentColor",
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M55.7813 164.688C64.5833 164.688 71.7188 157.552 71.7188 148.75C71.7188 139.948 64.5833 132.812 55.7813 132.812C46.9792 132.812 39.8438 139.948 39.8438 148.75C39.8438 157.552 46.9792 164.688 55.7813 164.688Z",
			strokeWidth: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "currentColor",
			d: "M120.035 143.402C119.702 144.794 119.533 146.221 119.532 147.652C119.135 153.6 122.083 159.273 127.178 162.367C132.273 165.462 138.666 165.462 143.761 162.367C148.856 159.273 151.804 153.6 151.407 147.652C151.408 146.221 151.239 144.794 150.904 143.402",
			strokeWidth: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "currentColor",
			d: "M29.2188 58.4375V74.375",
			strokeWidth: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "currentColor",
			d: "M124.844 69.0626C96.1704 50.3626 95.8021 48.6342 85.7225 48.6342C78.0358 48.595 71.7695 54.7884 71.7188 62.4751V85C71.7188 90.8681 76.4757 95.625 82.3438 95.625H92.9688C102.115 95.6249 110.235 101.477 113.128 110.153L118.908 127.5",
			strokeWidth: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("circle", {
			stroke: "currentColor",
			cx: 100,
			cy: 20,
			r: 15,
			strokeWidth: 10
		})
	]
});
const ForwardRef = forwardRef(SvgDeliveryPersonWhite);
export default ForwardRef;
